import yup from "yup";
import locale from "@bonliva-crm/locale";

export const payoutFormScheme = yup.object().shape({
  accountNumber: yup.string().required(locale.AccountNumber).nullable(true),
  clearingNumber: yup.string().required(locale.ClearingNumber).nullable(true),
  rate: yup.string().required(locale.Rate).nullable(true)
});
